import UserService from '../../helpers/authservice/user.service';
import router from '../../router/index';

export const state = {
    user: null,
    permissions: [],
    roles: []
};

export const actions = {
    login({ dispatch, commit }, { email, password }) {
        commit('loginRequest', { email });

        UserService.login(email, password)
            .then(
                user => {
                    commit('loginSuccess', user);
                    router.push('/');
                },
                error => {
                    commit('loginFailure', error);
                    dispatch('notification/error', error, { root: true });
                }
            );
    },

    logout({ commit }) {
        UserService.logout();
        commit('logout');
    },

    registeruser({ dispatch, commit }, user) {
        commit('registerRequest', user);
        UserService.register(user)
            .then(
                user => {
                    commit('registerSuccess', user);
                    dispatch('notification/success', 'Registration successful', { root: true });
                    router.push('/login');
                },
                error => {
                    commit('registerFailure', error);
                    dispatch('notification/error', error, { root: true });
                }
            );
    },

    getProfile({ commit }) {
        return UserService.verifyUser().then(
            data => {
                commit('loginSuccess', data.user);
                commit('SET_PERMISSIONS', data.permissions);
                commit('SET_ROLES', data.role);
                return Promise.resolve(data.user);
            },
            error => {
                commit('loginFailure');
                return Promise.reject(error);
            }
        );
    },
};

export const mutations = {
    loginRequest(state, user) {
        state.status = { loggingIn: true };
        state.user = user;
    },
    loginSuccess(state, user) {
        state.status = { loggeduser: true };
        state.user = user;
    },
    SET_PERMISSIONS(state, permissions) {
        state.permissions = permissions;
    },
    SET_ROLES(state, roles) {
        state.roles = roles;
    },
    loginFailure(state) {
        state.status = {};
        state.user = null;
    },
    logout(state) {
        state.status = {};
        state.user = null;
        state.permissions = [];
        state.roles = [];
    },
    registerRequest(state) {
        state.status = { registering: true };
    },
    registerSuccess(state) {
        state.status = {};
    },
    registerFailure(state) {
        state.status = {};
    }
};

export const getters = {
    getCurrentUser(state) {
        return state.user;
    },

    get_user_permissions(state) {
        return state.permissions;
    },

    get_user_role(state) {
        return state.roles;
    },

    hasPermission: (state) => (permission) => {
        if (!state.user) return false;
        // Super Admin has full access via the role (permissions may not be listed
        // individually on the flat permissions array). Mirror the router guard.
        if (Array.isArray(state.roles) && state.roles.some(r => r.name === 'Super Admin')) {
            return true;
        }
        if (!state.permissions) return false;
        return state.permissions.some(p => p.name === permission);
    },

    hasRole: (state) => (roleName) => {
        if (!state.user || !state.roles) return false;
        return state.roles.some(role => role.name === roleName);
    },
};
